(() => {
  // Normalize URLs so https://... and //... and relative URLs can still match
  const normalize = (u) => {
    const s = (u || "").trim();
    if (!s) return "";
    try {
      const url = new URL(s, window.location.href);
      // Ignore protocol + host; keep path + query (Shopify uses ?v=...)
      return url.pathname + url.search;
    } catch {
      return s;
    }
  };

  function findMainImgForZoom(zoomSrcNorm) {
    if (!zoomSrcNorm) return null;

    const mains = [...document.querySelectorAll("img[data-zoom-src]")];

    // 1) Best match: data-zoom-src equals zoom img src (normalized)
    let match = mains.find((m) => normalize(m.getAttribute("data-zoom-src")) === zoomSrcNorm);
    if (match) return match;

    // 2) Backup: main image current src equals zoom src (normalized)
    match = mains.find((m) => normalize(m.currentSrc || m.getAttribute("src")) === zoomSrcNorm);
    return match || null;
  }

  function fixZoomAlt(root = document) {
    const zoomImgs = root.querySelectorAll("img.zoomImg");
    if (!zoomImgs.length) return;

    zoomImgs.forEach((z) => {
      const existing = (z.getAttribute("alt") || "").trim();
      if (existing) return;

      const zoomSrcNorm = normalize(z.currentSrc || z.getAttribute("src"));
      if (!zoomSrcNorm) return;

      const main = findMainImgForZoom(zoomSrcNorm);

      // Copy alt from main if present
      const altFromMain = main ? (main.getAttribute("alt") || "").trim() : "";
      if (altFromMain) {
        z.setAttribute("alt", altFromMain);
        return;
      }

      // Fallback: page title (better than empty)
      const fallback = (document.title || "").trim();
      if (fallback) z.setAttribute("alt", fallback);
    });
  }

  // Run once
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => fixZoomAlt(document));
  } else {
    fixZoomAlt(document);
  }

  // Watch for injected zoom images
  const obs = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (!(node instanceof Element)) continue;

        if (node.matches?.("img.zoomImg")) {
          fixZoomAlt(document);
        } else if (node.querySelector?.("img.zoomImg")) {
          fixZoomAlt(node);
        }
      }
    }
  });

  obs.observe(document.documentElement, { childList: true, subtree: true });
})();
